<template>
  <div class="cadfm-container-horizontal">
            <Left :lang="lang.Left"></Left>
            <Middle   :lang="lang.Middle"></Middle>
            <!--<Right :lang="lang.Right"></Right>-->
 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/UL/Left/Left'
import Middle from '@/components/PartManager/Views/UL/Middle/Middle'
//import Right from '@/components/PartManager/Views/UL/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'Categories',
  components:{
    Left,
    Middle,
    //Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/UL.vue